import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { userById } from "../actions/userById";
import { cloudinaryUrl } from "../constants/CloudinaryConstants";
import { getDisplayName } from "../utils/displayName";
const Lender = ({ lender }) => {
  const [poster, setPoster] = useState(null);
  useEffect(() => {
    if (lender?.lender_used) {
      userById(lender?.lender_used, { setPoster });
    }
  }, [lender]);
  return (
    <>
      {lender && lender["lender_used"] && poster && (
        <>
          <h1 className="font-bold pt-8 mb-2">
            Selected Lender. Please contact this property's preferred lender by
            calling {poster?.phone_number}
          </h1>
          <Link
            to={`/user/${lender["lender_used"]}`}
            className="border-2 rounded-10 py-2 px-8 flex items-center justify-between hover:scale-105 hover:cursor-pointer transition-all w-[300px]"
          >
            <img
              className="h-[60px] w-[60px] object-cover rounded-full"
              src={
                poster?.picture_url
                  ? cloudinaryUrl(poster?.picture_url)
                  : "/error.png"
              }
              alt="lender"
            />
            <div className="w-max text-center">
              <h1 className="text-19">{getDisplayName(poster)}</h1>
              <p className="text-blue-500">{poster?.brokerage_name}</p>
              <p className="text-sm font-medium text-slate-700">
                {poster?.class_type}
              </p>
              {poster?.email_address && (
                <p className="text-xs text-slate-600 mt-1">
                  <a
                    href={`mailto:${poster.email_address}`}
                    className="hover:underline"
                  >
                    {poster.email_address}
                  </a>
                </p>
              )}
              {poster?.phone_number && (
                <p className="text-xs text-slate-600">
                  <a
                    href={`tel:${poster.phone_number}`}
                    className="hover:underline"
                  >
                    {poster.phone_number}
                  </a>
                </p>
              )}
            </div>
          </Link>
        </>
      )}
      {/* Fallback: Show free-text lender if set and no linked lender */}
      {lender && !lender["lender_used"] && lender["lender_text"] && (
        <div className="mt-6 p-4 border rounded-10 bg-white shadow w-[300px]">
          <h2 className="font-bold mb-2">Preferred Lender</h2>
          <p className="text-sm text-gray-700">{lender["lender_text"]}</p>
        </div>
      )}
    </>
  );
};

export default Lender;
